import { render, staticRenderFns } from "./PermissionForm.vue?vue&type=template&id=06565a5d&scoped=true&"
import script from "./PermissionForm.vue?vue&type=script&lang=js&"
export * from "./PermissionForm.vue?vue&type=script&lang=js&"
import style0 from "./PermissionForm.vue?vue&type=style&index=0&id=06565a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06565a5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
